import React, { useEffect, useState } from "react";
import Closed from "../component/app/closed";

function Timer() {
  const [status, setstatus] = useState(false);
  const [second, setsecond] = useState(0);
  const [minute, setminute] = useState(0);
  const [hour, sethour] = useState(0);
  useEffect(() => {
    var int = setInterval(() => {
      if (status) {
        setstatus(true);
        setsecond(second - 1);
        if (second <= 0) {
          setsecond(60);
          setminute(minute - 1);
        }
        if (minute <= 0) {
          setsecond(60);
          setminute(0);
          if (hour >= 1) {
            sethour(minute - 1);
          }
        }
        if (hour === 0) {
          if (minute === 0) {
            setTimeout(() => {
              if (second <= 0) {
                setstatus(false);
              }
            }, 4000);
          }
        }
      }
    }, 1000);
    return () => clearInterval(int);
  }, [minute, second, status, hour]);
  return (
    <div className="flex flex-wrap justify-center w-full mt-6">
      {status ? (
        <h5 className="font-medium text-4xl">
          {hour}:{minute}:{second}
        </h5>
      ) : (
        <form className="w-full">
          <div className="flex flex-wrap sm:flex-nowrap space-x-1 space-y-2 justify-center">
            <div className=""></div>
            <input
              type="number"
              max="24"
              placeholder="Hour"
              onKeyUp={(e) => sethour(e.target.value)}
              className="border w-full sm:w-1/3 p-2 focus:outline-none"
            />
            <input
              type="number"
              max="60"
              placeholder="Minute"
              onKeyUp={(e) => setminute(e.target.value)}
              className="border w-full sm:w-1/3 p-2 focus:outline-none"
            />
            <input
              type="number"
              max="60"
              placeholder="Second"
              onKeyUp={(e) => setsecond(e.target.value)}
              className="border w-full sm:w-1/3 p-2 focus:outline-none"
            />
          </div>
        </form>
      )}
      <div className="flex justify-center w-full mt-6 space-x-1">
        <button
          onClick={(e) => setstatus(true)}
          className="p-4 rounded-md bg-green-400 text-white focus:outline-none"
        >
          Start
        </button>
        <button
          onClick={(e) => {
            setstatus(false);
            setsecond(0);
            setminute(0);
            sethour(0);
          }}
          className="p-4 rounded-md bg-red-400 text-white focus:outline-none"
        >
          Reset
        </button>
      </div>
    </div>
  );
}

export default function Alarm(props) {
  let db = localStorage.getItem("alarm");
  const [container] = useState(
    "bg-white w-full sm:w-1/2 lg:w-2/5 transition-all duration-500 transform "
  );
  const [realtime, setrealtime] = useState({
    second: ""
  });
  const [tabs, settabs] = useState({
    active: "Alarm",
    list: ["Alarm", "Stopwatch", "Timer"]
  });
  const [alarm, setalarm] = useState({
    input: {
      date: "",
      time: ""
    },
    list: JSON.parse(db)
  });
  const [startwatch, setstartwatch] = useState(false);
  const [time, settime] = useState(0);
  const [minute, setminute] = useState(0);
  const [hour, sethour] = useState(0);
  useEffect(() => {
    if (startwatch) {
      var intr = setInterval(() => {
        settime(time + 1);
        if (time >= 60) {
          settime(0);
          setminute(minute + 1);
        }
        if (minute >= 60) {
          settime(0);
          setminute(0);
          sethour(hour + 1);
        }
      }, 1000);
    }
    return () => clearInterval(intr);
  }, [startwatch, time, minute, hour]);
  function alarm_action() {
    return {
      add() {
        setalarm({ input: "", list: [...alarm.list, alarm.input] });
        localStorage.setItem(
          "alarm",
          JSON.stringify([...alarm.list, alarm.input])
        );
      },
      delete(date, time) {
        var data = alarm.list.filter((d) => {
          if (d.date !== date && d.time !== time) return true;
        });
        setalarm({
          input: alarm.input,
          list: data
        });
        localStorage.setItem("alarm", JSON.stringify(data));
      },
      insert(val, type) {
        if (type === "date") {
          return setalarm({
            input: {
              date: val,
              time: alarm.input.time
            },
            list: alarm.list
          });
        }
        return setalarm({
          input: {
            date: alarm.input.date,
            time: val
          },
          list: alarm.list
        });
      }
    };
  }
  useEffect(() => {
    if (props.open) {
      var int = setInterval(() => {
        var date = new Date();
        setrealtime({
          second: date.getSeconds(),
          minute: date.getMinutes(),
          hour: date.getHours(),
          day: date.getDate(),
          month: date.getMonth(),
          year: date.getFullYear()
        });
      }, 1000);
      return () => clearInterval(int);
    }
    console.log(props.open);
  }, [realtime.second, props.open]);
  if (props.open) {
    return (
      <div
        className={
          props.open ? container + "scale-100" : container + "scale-0 hidden"
        }
      >
        <Closed name="Alarm" />
        <div className="h-92vh overflow-auto">
          <div className="flex flex-wrap justify-center relatife p-6">
            <div className="w-full border p-2 text-center">
              <h5 className="text-6xl">
                {realtime.hour}:{realtime.minute}:{realtime.second}
              </h5>
              <h6 className="mt-2">
                {realtime.year}/{realtime.month}/{realtime.day}
              </h6>
            </div>
            <div className="w-full mt-2">
              <div className="flex w-full border-b border-blue-700 justify-center">
                {tabs.list.map((d, i) => (
                  <p
                    key={i}
                    onClick={(e) => settabs({ list: tabs.list, active: d })}
                    className={
                      tabs.active === d
                        ? "p-2 cursor-pointer transition-all duration-500 hover:bg-blue-900 bg-blue-800 text-white"
                        : "p-2 cursor-pointer hover:bg-gray-50 transition-all duration-500"
                    }
                  >
                    {d}
                  </p>
                ))}
              </div>
              <div className="flex flex-wrap justify-center">
                {tabs.active === "Alarm" ? (
                  <>
                    <form className="w-full mt-2">
                      <input
                        className="bg-white focus:outline-none border w-full p-3"
                        type="date"
                        onChange={(e) =>
                          alarm_action().insert(e.target.value, "date")
                        }
                      />
                      <input
                        className="bg-white focus:outline-none border w-full p-3 mt-2"
                        type="time"
                        onChange={(e) =>
                          alarm_action().insert(e.target.value, "time")
                        }
                      />
                    </form>
                    <button
                      onClick={(e) => alarm_action().add()}
                      className="p-3 bg-green-400 text-white my-2 focus:outline-none"
                    >
                      Create Alarm
                    </button>
                    <div className="border-t w-full">
                      <h5 className="p-3">List Alarm</h5>
                      {alarm.list.length === 0 ? (
                        <p className="text-center">No New Alarm On List</p>
                      ) : (
                        false
                      )}
                      {alarm.list.map((d, i) => (
                        <div className="border-l-4 p-3 mt-1 flex" key={i}>
                          <p className="w-4/5">
                            {d.date} {d.time}
                          </p>
                          <div className="text-right w-1/5">
                            <i
                              onClick={(e) =>
                                alarm_action().delete(d.date, d.time)
                              }
                              className="fas fa-trash-alt cursor-pointer"
                            ></i>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  false
                )}
                {tabs.active === "Stopwatch" ? (
                  <>
                    <div className="flex justify-center w-full mt-10">
                      <h5 className="font-medium text-4xl">
                        {hour}:{minute}:{time}
                      </h5>
                    </div>
                    <div className="flex justify-center space-x-1 w-full mt-8">
                      <button
                        onClick={(e) =>
                          startwatch
                            ? setstartwatch(false)
                            : setstartwatch(true)
                        }
                        className="p-4 rounded-md bg-green-400 text-white focus:outline-none"
                      >
                        {startwatch ? "Pause" : "Start"}
                      </button>
                      <button
                        onClick={(e) => {
                          setstartwatch(false);
                          settime(0);
                          setminute(0);
                          sethour(0);
                        }}
                        className="p-4 rounded-md bg-red-400 text-white focus:outline-none"
                      >
                        Reset
                      </button>
                    </div>
                  </>
                ) : (
                  false
                )}
                {tabs.active === "Timer" ? (
                  <>
                    <Timer />
                  </>
                ) : (
                  false
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
